import { onValue } from 'firebase/database';

// How often a page may re-read the whole fleet. mdm/devices is ~1.4 MB for ~300 devices and
// changes ~20 times a second (every device heartbeats). Rebuilding and re-rendering all of it on
// every change is fine on a fast PC but drowns a TV browser: the queue of pending snapshots
// grows faster than it can render, the JS heap reaches its limit (640 MB seen on a Hisense
// DM66D), clicks stop working and the browser crashes. A dashboard needs a fresh view every
// couple of seconds, not twenty times a second.
export const FLEET_REFRESH_MS = 2000;

/**
 * onValue() that hands the callback the LATEST snapshot at most once per intervalMs.
 *
 * The first value is delivered immediately; changes arriving in between are coalesced and the
 * newest one is delivered when the interval ends, so nothing is lost - the view is at most
 * intervalMs behind. snap.val() is left to the callback, so a skipped snapshot is never turned
 * into a JS object at all. Same arguments and return value as onValue(), plus the interval.
 */
export function onValueThrottled(query, callback, onError, intervalMs = FLEET_REFRESH_MS) {
    let latest = null;
    let timer = null;
    let lastDelivered = 0;
    let closed = false;

    const deliver = () => {
        timer = null;
        if (closed || latest === null) return;
        const snap = latest;
        latest = null;
        lastDelivered = Date.now();
        callback(snap);
    };

    const unsubscribe = onValue(
        query,
        (snap) => {
            latest = snap;
            if (timer !== null) return;
            timer = setTimeout(deliver, Math.max(0, lastDelivered + intervalMs - Date.now()));
        },
        onError
    );

    return () => {
        closed = true;
        if (timer !== null) clearTimeout(timer);
        unsubscribe();
    };
}
